import _ from 'underscore';
import Backbone from 'backbone';

import TrackerCollection from 'core/collections/tracker';


export default TrackerCollection.extend({
  constructor: function (models, options) {
    _.bindAll(this, 'change_date');

    // Super
    TrackerCollection.apply(this, arguments);

    this.date_nav = options && options.date_nav;
    if (this.date_nav) {
      this.change_date();
      this.date_nav.on('change', this.change_date);
    }
  },

  change_date: function (selected_date, previous_date) {
    this.params.date__gte = this.date_nav.formatted_date(this.date_nav.start_date());
    this.params.date__lte = this.date_nav.formatted_date(this.date_nav.end_date());

    // Only fetch when change_date was triggered by an event
    if (selected_date) {
      this.fetch();
    }
  }
});



// WEBPACK FOOTER //
// ./static/js/collections/date.js